import { RefObject, useEffect, useState } from 'react';
import { useWindowSize } from './useWindowSize';

// inspired by https://github.com/amorriscode/use-overflow/

export const useOverflow = (ref: RefObject<HTMLElement>) => {
  const [isXOverflowing, setIsXOverflowing] = useState(false);
  const [isYOverflowing, setIsYOverflowing] = useState(false);

  const [isXScrollBegin, setIsXScrollBegin] = useState(true);
  const [isXScrollEnd, setIsXScrollEnd] = useState(false);

  const [isYScrollBegin, setIsYScrollBegin] = useState(true);
  const [isYScrollEnd, setIsYScrollEnd] = useState(false);

  const size = useWindowSize();

  useEffect(() => {
    const current = ref.current;

    if (!current) {
      return;
    }

    setIsXOverflowing(current.scrollWidth > current.clientWidth);
    setIsYOverflowing(current.scrollHeight > current.clientHeight);

    const handleScroll = (): void => {
      // Handle X Overflow
      const offsetRight = current.scrollWidth - current.clientWidth;
      setIsXScrollEnd(current.scrollLeft >= offsetRight);
      setIsXScrollBegin(current.scrollLeft === 0);

      // Handle Y Overflow
      const offsetBottom = current.scrollHeight - current.clientHeight;
      setIsYScrollEnd(current.scrollTop >= offsetBottom);
      setIsYScrollBegin(current.scrollTop === 0);
    };

    current.addEventListener('scroll', handleScroll);

    // update when window size changes
    handleScroll();

    return (): void => current?.removeEventListener('scroll', handleScroll);
  }, [ref, size.width]);

  return {
    isXOverflowing,
    isXScrollBegin,
    isXScrollEnd,
    isYOverflowing,
    isYScrollBegin,
    isYScrollEnd,
  };
};
